import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DealUiModule } from '../../ui/deal-ui.module'
import { UiModule } from '../../../../ui/monolith/ui.module'
import { RouterModule } from '@angular/router'
import { CheckoutStickyNavComponent } from './components/checkout-sticky-nav/checkout-sticky-nav.component'
import { CheckoutAccordionRouteComponent } from './components/checkout-accordion-route/checkout-accordion-route.component'
import { ConfiguratorComponent } from './components/configurator/configurator.component'
import { ConfiguratorMainComponent } from './components/configurator/configurator-main.component'
import { ConfiguratorContentComponent } from './components/configurator/configurator-content.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CheckoutAccordionContentComponent } from './components/checkout-accordion-content/checkout-accordion-content.component'
import { CheckoutAccordionTabComponent } from './components/checkout-accordion-tab/checkout-accordion-tab.component'
import { CheckoutAccordionComponent } from './components/checkout-accordion/checkout-accordion.component'
import { CheckoutAccordionWrapperComponent } from './components/checkout-accordion-wrapper/checkout-accordion-wrapper.component'
import { CheckoutCompanyPickerComponent } from './components/checkout-company-picker/checkout-company-picker.component'
import { CheckoutDriverComponent } from './components/checkout-driver/checkout-driver.component'
import { ConfiguratorColorpickerComponent } from './components/configurator-colorpicker/configurator-colorpicker.component'
import { ConfiguratorColorpickerColorComponent } from './components/configurator-colorpicker-color/configurator-colorpicker-color.component'
import { ConfiguratorRimspickerComponent } from './components/configurator-rimspicker/configurator-rimspicker.component'
import { ConfiguratorRimspickerOptionComponent } from './components/configurator-rimspicker-option/configurator-rimspicker-option.component'
import { ConfiguratorOptiongroupComponent } from './components/configurator-optiongroup/configurator-optiongroup.component'
import { ConfiguratorOptiongroupOptionComponent } from './components/configurator-optiongroup-option/configurator-optiongroup-option.component'
import { ConfiguratorSelectComponent } from './components/configurator-select/configurator-select.component'
import { ConfiguratorSelectOptionComponent } from './components/configurator-select-option/configurator-select-option.component'
import { ConfiguratorCheckboxComponent } from './components/configurator-checkbox/configurator-checkbox.component'
import { ConfiguratorSwitchComponent } from './components/configurator-switch/configurator-switch.component'
import { ConfiguratorSwitchOptionComponent } from './components/configurator-switch-option/configurator-switch-option.component'
import { CheckoutLegalAgreementComponent } from './components/checkout-legal-agreement/checkout-legal-agreement.component'
import { CheckoutLegalAgreementPreviewComponent } from './components/checkout-legal-agreement/checkout-legal-agreement-preview.component'
import { CheckoutPaymentMethodComponent } from './components/checkout-payment-method/checkout-payment-method.component'
import { CheckoutOptionsLayoutComponent } from './components/checkout-options-layout/checkout-options-layout.component'
import { OptionTranslationPipe } from 'modules/deals/ui/pipes/option-translation.pipe'
import { CheckoutSidebarComponent } from './components/checkout-sidebar/checkout-sidebar.component'
import { CheckoutReferralBannerComponent } from './components/checkout-referral-banner/checkout-referral-banner.component'
import { CheckoutActionBannerComponent } from './components/checkout-action-banner/checkout-action-banner.component'
import { TenantCurrencyModule } from 'framework/tenant-currency/tenant-currency.module'
import { AccessoryKeyValueFilter } from './accessoryKeyValueFilter'
import { ConfiguratorSteeringWheelpickerComponent } from './components/configurator-steeringwheelpicker/configurator-steeringwheel-picker.component'
import { ConfiguratorSteeringWheelpickerOptionComponent } from './components/configurator-steeringwheelpicker-option/configurator-steeringwheel-picker-option.component'

export const COMPONENTS = [
    CheckoutAccordionComponent,
    CheckoutAccordionWrapperComponent,
    CheckoutAccordionTabComponent,
    CheckoutAccordionContentComponent,
    CheckoutAccordionRouteComponent,
    CheckoutStickyNavComponent,
    ConfiguratorComponent,
    ConfiguratorMainComponent,
    ConfiguratorContentComponent,
    CheckoutCompanyPickerComponent,
    CheckoutDriverComponent,
    ConfiguratorColorpickerComponent,
    ConfiguratorColorpickerColorComponent,
    ConfiguratorRimspickerComponent,
    ConfiguratorRimspickerOptionComponent,
    ConfiguratorSteeringWheelpickerComponent,
    ConfiguratorSteeringWheelpickerOptionComponent,
    ConfiguratorOptiongroupComponent,
    ConfiguratorOptiongroupOptionComponent,
    ConfiguratorSelectComponent,
    ConfiguratorSelectOptionComponent,
    ConfiguratorCheckboxComponent,
    ConfiguratorSwitchComponent,
    ConfiguratorSwitchOptionComponent,
    CheckoutLegalAgreementComponent,
    CheckoutLegalAgreementPreviewComponent,
    CheckoutPaymentMethodComponent,
    CheckoutReferralBannerComponent,
    CheckoutOptionsLayoutComponent,
    CheckoutSidebarComponent,
    CheckoutActionBannerComponent,
    AccessoryKeyValueFilter,
]

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DealUiModule,
        UiModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        MatSelectModule,
        MatInputModule,
        MatProgressBarModule,
        MatIconModule,
        MatListModule,
        MatButtonModule,
        MatRadioModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatMenuModule,
        TenantCurrencyModule,
    ],
    declarations: COMPONENTS,
    providers: [OptionTranslationPipe],
    exports: COMPONENTS,
})
export class CheckoutUiModule {}
